import React from 'react'
import moment from 'moment'
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import './Transactions.css'
import Card, {StickyCard, TitleCard} from '../core/Card'
import SideNav from '../layout/SideNav'
import { Icon, BackIcon, BriefcaseIcon, CoinIcon, RefundIcon } from '../core/icons'
import { Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown, Row, Col, message, Menu, Popconfirm } from 'antd';
import { connect } from 'react-redux'
import Summary from './Summary'
import { withPreviousDate, getPurposes } from './reducer'
import TransactionLine from './TransactionLine'
import EmptyState from '../core/components/EmptyState'
import Filter from './Filter'
import { StickyContainer, Sticky } from 'react-sticky';
import BulkActions from './BulkActions'
import styled, {css, keyframes} from 'styled-components'

var isMobile = document ?
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 550
  : false

const Actions = styled.span`
    display: flex;
    float: right;
    > button {
      margin-right: 10px;
    }
`


const TitleBar = ({style}) =>
  <TitleCard sticky>
    <h1>Transactions</h1>
    <Actions id="Actions">

      <Filter/>
      <Dropdown trigger={['click']} overlay={(
        <Menu>
          <Menu.Item key="1">
            <Link to="/transactions/new/expense">
            <Row type="flex" justify="start" align="middle">
              <CoinIcon/>
              <div style={{marginLeft: "8px"}}>Expense</div>
            </Row>
          </Link>
        </Menu.Item>
        <Menu.Item key="2">

          <Link to="/transactions/new/revenue">
            <Row type="flex" justify="start" align="middle">
              <RefundIcon/>
              <div style={{marginLeft: "8px"}}>Revenue</div>
            </Row>
          </Link>

          </Menu.Item>
        </Menu>
      )}>
      <Button>
        New{ (!isMobile)&&' Transaction'} <AIcon type="down" />
      </Button>
    </Dropdown>
  </Actions>
</TitleCard>




export default TitleBar



// WEBPACK FOOTER //
// ./src/transactions/TitleBar.js